import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "./Login";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      {done ? (
        <div className="text-center" data-testid="reset-success">
          <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto mb-4" aria-hidden="true" />
          <h1 className="font-heading text-2xl font-bold tracking-tight mb-2">Password updated</h1>
          <p className="text-sm text-muted-foreground">You can now sign in with your new password.</p>
          <Button asChild className="mt-6 rounded-md"><Link to="/login">Sign in</Link></Button>
        </div>
      ) : (
        <>
          <div className="overline mb-2">Account recovery</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Set new password</h1>
          <p className="text-sm text-muted-foreground mb-6">Choose a strong new password.</p>
          {error && <div className="mb-4 text-sm text-destructive" data-testid="reset-error">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">New password</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-1.5 rounded-md" />
            </div>
            <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="w-full rounded-md">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" aria-hidden="true" />}
              Update password
            </Button>
          </form>
        </>
      )}
    </AuthShell>
  );
}
